import { DeterministicView } from '@bingads-webui/deterministic-view';
import template from './hotel-center-intelligence-template.pug';
import * as intelligenceSubSections from './intelligence-sub-sections';
import IntelligenceTreeBars from './intelligence-tree-bars';
import FeedStatus from './sub-sections/feed-status/feed-status';
import FeedUpload from './sub-sections/feed-upload/feed-upload';
import MatchReport from './sub-sections/match-report/match-report';
import ShareOfVoice from './sub-sections/share-of-voice-report/share-of-voice-report';
import BookingReport from './sub-sections/booking-report/booking-report';
import { CalloutExtensionsView } from './sub-sections/callout-extensions';
import { feedErrorMapper } from './sub-sections/feed-upload/feed-error-map';

export {
  FeedStatus,
  FeedUpload,
  MatchReport,
  ShareOfVoice,
  BookingReport,
  feedErrorMapper,
  intelligenceSubSections,
  IntelligenceTreeBars,
  CalloutExtensionsView,
};

/**
 * Class representing a navigation tabs for HotelCenter intelligence
 * @extends DeterministicView
 */
export class HotelCenterIntelligence extends DeterministicView {
  /**
  * Initializes HotelCenterIntelligence
  * @returns {undefined}
  */
  initialize({ perfMarker } = {}) {
    this.intelligenceTreeBars = new IntelligenceTreeBars();
    this.setState({ selectedSubSectionName: 'Feed Upload' });
    this.setChild('intelligence-tree-bar', this.intelligenceTreeBars);
    this.listenTo(this.intelligenceTreeBars, 'selected', (data) => {
      this.setState({ selectedSubSectionName: data.name });
    });
    this.perfMarker = perfMarker;
  }

  renderTrunk() {
    super.renderTrunk();

    const {
      selectedSubSectionName,
    } = this.getState();

    // set feed status as default pages
    switch (selectedSubSectionName) {
      case 'Matching Report':
        this.setChild('match-report', new MatchReport({ perfMarker: this.perfMarker }));
        break;
      case 'Feed Status':
        this.setChild('feed-status', new FeedStatus({ perfMarker: this.perfMarker }).render());
        break;
      case 'SOV Report':
        this.setChild('sov-report', new ShareOfVoice({ perfMarker: this.perfMarker }));
        break;
      case 'Booking Report':
        this.setChild('booking-report', new BookingReport({ perfMarker: this.perfMarker }));
        break;
      case 'Callout Extensions':
        this.setChild('callout-extensions', new CalloutExtensionsView({ perfMarker: this.perfMarker }));
        break;
      case 'Feed Upload':
      default:
        // Since FeedStatus is a BaseView, we need to call render explicitly
        this.setChild('feed-upload', new FeedUpload({ perfMarker: this.perfMarker }));
        break;
    }

    return this;
  }

  get template() {
    return template;
  }
}
